export default "__VITE_ASSET__ffe8f6a9__"